import { useCallback, useState } from 'react';
import { generatePath } from 'react-router-dom';

import { apiPaths } from 'src/services/api/apiPaths';
import HttpServiceInstance from 'src/services/api/http';
import { useDashboardFilters } from 'src/components/dashboard/hooks';
import { useDownloadManager } from 'src/components/downloadManager/DownloadManagerContext';

export const useDownloadClickHandler = (widgetId: number) => {
  const { poll } = useDownloadManager();
  const [loading, setLoading] = useState(false);

  const { flatFilters, filterGroups } = useDashboardFilters();

  const handleDownloadClick = useCallback(async () => {
    setLoading(true);

    try {
      return await HttpServiceInstance.post(
        generatePath(apiPaths.DASHBOARD.EXPORT_RESPONSE_RATE, { widgetId }),
        {
          ...flatFilters,
        },
      );
    } finally {
      poll();
      setLoading(false);
    }
  }, [filterGroups, widgetId, poll]);

  return { loading, handleDownloadClick };
};

export default useDownloadClickHandler;
